import { all, call, put, select, takeLatest } from "redux-saga/effects";
import api from "../../utils/api";
import { errorAlert } from "../Alerts/actions";
import { fetchAiWallets } from "../AICredits/actions";
import {
  fetchAiSuggestionsSuccess,
  fetchAiSuggestionsFailure,
} from "./actions";
import {
  GENERATE_AI_SUGGESTIONS,
  FETCH_AI_SUGGESTIONS,
  ACCEPT_AI_SUGGESTION,
  DISMISS_AI_SUGGESTION,
} from "./constants";

export function* generateAiSuggestionsSaga({ payload, onSuccess, onError }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { residentId, templateId, carePlanId, target, locationId } =
    payload || {};
  try {
    const { data } = yield call(
      api(token).post,
      `/api/resident/${residentId}/ai-suggestions/generate`,
      {
        template_id: templateId,
        care_plan_id: carePlanId ?? null,
        target: target ?? "schedule",
      },
      { timeout: 300000 },
    );
    // A generate turn spends a care_planning credit — refresh the wallet.
    if (data && !data.ai_unavailable && locationId) {
      yield put(fetchAiWallets({ location_id: locationId }));
    }
    if (onSuccess) onSuccess(data);
  } catch (e) {
    if (onError) onError(e);
  }
}

export function* fetchAiSuggestionsSaga({ payload, onSuccess, onError }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { residentId, carePlanId, target } = payload || {};
  try {
    const params = [];
    if (carePlanId)
      params.push(`care_plan_id=${encodeURIComponent(carePlanId)}`);
    if (target) params.push(`target=${encodeURIComponent(target)}`);
    const qs = params.length ? `?${params.join("&")}` : "";
    const { data } = yield call(
      api(token).get,
      `/api/resident/${residentId}/ai-suggestions${qs}`,
    );
    const items = Array.isArray(data) ? data : [];
    yield put(fetchAiSuggestionsSuccess({ carePlanId, target, items }));
    if (onSuccess) onSuccess(items);
  } catch (e) {
    yield put(fetchAiSuggestionsFailure(e));
    if (onError) onError(e);
  }
}

export function* acceptAiSuggestionSaga({ payload, onSuccess, onError }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { residentId, uuid } = payload || {};
  try {
    const { data } = yield call(
      api(token).post,
      `/api/resident/${residentId}/ai-suggestions/${uuid}/accept`,
      {},
    );
    if (onSuccess) onSuccess(data);
  } catch (e) {
    if (onError) onError(e);
    else yield put(errorAlert("Could not save the suggestion."));
  }
}

export function* dismissAiSuggestionSaga({ payload, onSuccess, onError }) {
  const token = yield select((state) => state?.AuthReducer?.token);
  const { residentId, uuid, reason } = payload || {};
  try {
    const { data } = yield call(
      api(token).post,
      `/api/resident/${residentId}/ai-suggestions/${uuid}/dismiss`,
      { reason: reason ?? null },
    );
    if (onSuccess) onSuccess(data);
  } catch (e) {
    if (onError) onError(e);
  }
}

export default function* AiSuggestionsSaga() {
  yield all([
    takeLatest(GENERATE_AI_SUGGESTIONS, generateAiSuggestionsSaga),
    takeLatest(FETCH_AI_SUGGESTIONS, fetchAiSuggestionsSaga),
    takeLatest(ACCEPT_AI_SUGGESTION, acceptAiSuggestionSaga),
    takeLatest(DISMISS_AI_SUGGESTION, dismissAiSuggestionSaga),
  ]);
}
